import * as actionTypes from '../actions/actionTypes';
import moment from "moment";

import { updateObject } from '../utility';

const initialState = {
    destination: '',
    destinationCity: null,
    destinationCountry: null,
    destinationValid: true,
    destinationTooltip: false,
    middleContainer: true,
    autoSuggestBox: false,
    checkinDate: moment(),
    checkoutDate: null
}

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.SET_HOTEL_DESTINATION_CITY:
            return updateObject(state, { destination: action.city, destinationCity: action.city, destinationCountry: action.countryCode, middleContainer: true, autoSuggestBox: false })
        case actionTypes.SEARCH_HOTEL_DESTINATION_CITY:
            return updateObject(state, { destination: action.city, destinationValid: true, destinationTooltip: false, middleContainer: false, autoSuggestBox: true})
        case actionTypes.SET_HOTEL_DESTINATION_VALIDATION:
            return updateObject(state, { destinationValid: false, destinationTooltip: true });
        case actionTypes.SET_HOTEL_CHECKIN_DATE:
            return updateObject(state, { checkinDate: action.checkinDate })
        case actionTypes.SET_HOTEL_CHECKOUT_DATE:
            return updateObject(state, { checkinDate: action.checkinDate, checkoutDate: action.checkoutDate })
        case actionTypes.CLEAR_END_DATE:
            return updateObject(state, { checkoutDate: null })
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/bookingEngineHotel.js